import { CourseLabelApiModel, CourseLabelModel } from './courseLabel.model';

export const courseLabelAdapter = (
  courseLabel: CourseLabelApiModel
): CourseLabelModel => ({
  title: courseLabel.title,
  color: courseLabel.font_color,
  background: courseLabel.background,
});
